import React from "react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/AuthContext";
import { useNavigate } from "react-router-dom";

const FederalPlans: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  // Check if user has federal plan access
  if (!auth?.currentUser?.module_federal_plan) {
    return (
      <div className="container mx-auto p-8">
        <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
        <p>You don't have access to federal plans.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold">Federal Plans</h1>
        <Button onClick={() => navigate("/federal-plans/new")}>
          Create Plan
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* FEGLI Card */}
        <div className="border rounded-lg p-6 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">FEGLI</h2>
          <p className="text-gray-600 mb-4">
            Federal Employees' Group Life Insurance
          </p>
          <Button
            variant="outline"
            onClick={() => navigate("/federal-plans/fegli")}
          >
            View Details
          </Button>
        </div>

        {/* TSP Card */}
        <div className="border rounded-lg p-6 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">TSP</h2>
          <p className="text-gray-600 mb-4">Thrift Savings Plan</p>
          <Button
            variant="outline"
            onClick={() => navigate("/federal-plans/tsp")}
          >
            View Details
          </Button>
        </div>

        {/* Federal Retirement Card */}
        <div className="border rounded-lg p-6 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">Federal Retirement</h2>
          <p className="text-gray-600 mb-4">Federal Retirement Benefits</p>
          <Button
            variant="outline"
            onClick={() => navigate("/federal-plans/retirement")}
          >
            View Details
          </Button>
        </div>
      </div>

      {/* Plans Table */}
      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-4">Your Plans</h2>
        <div className="border rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Plan Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Last Updated
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">
                    FEGLI Basic
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                    Active
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  2024-03-20
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => navigate("/federal-plans/edit/1")}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FederalPlans;
